export default __webpack_public_path__ + "static/media/default.c08c3ad6b4d5c6c1abe0385298cbc183.png";